import { apiCall } from './apiCall_v2';
import { TOKEN_EGRESADOS, NAME_TOKEN as TOKEN_CMI,TOKEN_EMP_BY_EGRESADOS } from "./../shared/constants"; 
 
export const cmiApiCall = apiCall(TOKEN_CMI);
export const egresadosApiCall = apiCall(TOKEN_EGRESADOS, "egresados");
export const empresasByEgresadosApiCall = apiCall(TOKEN_EMP_BY_EGRESADOS, "empresa");
